import React from "react";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
      error: null,
      errorInfo: null,
    };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({ errorInfo });

    // Optional: send error details to a logging service
    if (typeof this.props.onError === "function") {
      this.props.onError(error, errorInfo);
    }
  }

  render() {
    if (this.state.hasError) {
      if (this.props.fallback) {
        return typeof this.props.fallback === "function"
          ? this.props.fallback({
              error: this.state.error,
              errorInfo: this.state.errorInfo,
            })
          : this.props.fallback;
      }

      return (
        <div style={{ padding: "16px", border: "1px solid #ddd", borderRadius: "8px", backgroundColor: 'white', height: '100%' }}>
          <h2>Something went wrong.</h2>
          {this.state.error && (
            <details style={{ whiteSpace: "pre-wrap", marginTop: "8px" }}>
              <summary>Error details</summary>
              {this.state.error.toString()}
              {"\n"}
              {this.state.errorInfo?.componentStack}
            </details>
          )}
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;